import React from "react";

/** Display-sized WebP assets (~44px tall @2x). Preloaded from the document head on `/`. */
export const PARTNERS = [
    { src: "/images/partners/optspot-logo.webp", alt: "OptSpot", w: 150, h: 44 },
    { src: "/images/partners/BBB-logo-new.webp", alt: "BBB Accredited Business", w: 150, h: 44 },
    { src: "/images/partners/forbees.webp", alt: "Forbes", w: 120, h: 44 },
    { src: "/images/partners/IFA-Supplier-Forum-new.webp", alt: "IFA Supplier Forum", w: 150, h: 44 },
    { src: "/images/partners/IFA-Member-Logo-new.webp", alt: "IFA Member", w: 150, h: 44 },
    { src: "/images/partners/google-cloud-new.webp", alt: "Google Cloud", w: 150, h: 44 },
    { src: "/images/partners/doordash-logo-new.webp", alt: "DoorDash", w: 140, h: 44 },
    { src: "/images/partners/ick-new.webp", alt: "ICK", w: 120, h: 44 },
    { src: "/images/partners/campaing-regestry.webp", alt: "Campaign Registry", w: 150, h: 44 },
    { src: "/images/partners/dennys.webp", alt: "Denny's", w: 120, h: 44 },
    { src: "/images/partners/asian-chamber-of-commerce.webp", alt: "Asian Chamber of Commerce", w: 150, h: 44 },
];

const PartnersCarousel = () => (
    <section className="clk-partners">
        <div className="clk-container">
            <p className="clk-partners-label">Trusted by teams and partners</p>
            <div className="clk-partners-marquee">
                <div className="clk-partners-track">
                    {PARTNERS.map((p) => (
                        <img
                            key={p.src}
                            src={p.src}
                            alt={p.alt}
                            width={p.w}
                            height={p.h}
                            loading="eager"
                            decoding="sync"
                            fetchpriority="high"
                            className="clk-partner-logo"
                        />
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default PartnersCarousel;
